/**
 * @generated SignedSource<<41e11deac6c39ff6d176dc3313f58d1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetTypeNameNode$data = {
  readonly __typename: string;
  readonly entityId: string;
  readonly parentSection?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckCanShowInPlusPlatformArticle" | "helpersCheckIsNewsAgendaTopicTopic" | "helpersCheckIsPlusArticle">;
  readonly " $fragmentType": "helpersGetTypeNameNode";
};
export type helpersGetTypeNameNode$key = {
  readonly " $data"?: helpersGetTypeNameNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetTypeNameNode">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetTypeNameNode"
};

(node as any).hash = "2d828affd93d6de6ddc5b75ec2d51865";

export default node;
